
export const ossL = (res) => {
    // if (process.env.NODE_ENV == "development") {
        // return 'https://yezai.oss-cn-shenzhen.aliyuncs.com/' + res
        // return 'https://yezai-prod.oss-cn-shenzhen.aliyuncs.com/' + res

    // } else if (process.env.NODE_ENV == "production") {
        return 'https://yezai-prod.oss-cn-shenzhen.aliyuncs.com/' + res
    // }
}